const useTrackingIconOptions = () => {
  const enabledOptions = [
    { value: 'true', label: 'Sí' },
    { value: 'false', label: 'No' },
  ];
  const typeOptions = [
    { value: 'all', label: 'Todos' },
    { value: 'true', label: 'Predeterminados' },
    { value: 'false', label: 'Especiales' },
  ];

  return { enabledOptions, typeOptions };
};

export default useTrackingIconOptions;
